// This is a purely presentational component, use with DownloadButtonWrapper.
import React from 'react';

interface DownloadButtonProps {
  styleAsDownloaded?: boolean;
  isExternalSource?: boolean;
  onDownloadClick?: () => void;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
  styleAsDownloaded = false,
  isExternalSource = false,
  onDownloadClick,
}) => (
  <button className="work-card--action-button" onClick={onDownloadClick}>
    <i
      className="fa fa-arrow-down"
      style={{
        fontSize: 12,
        marginRight: 6,
      }}
    />
    {isExternalSource
      ? 'View ↗'
      : styleAsDownloaded
        ? 'Downloaded'
        : 'Download'}
  </button>
);

export default DownloadButton;
